import { Layout } from "@/components/layout/Layout";
import { KioskLockOverlay } from "@/features/kiosk-lock/kiosk-lock-overlay/KioskLockOverlay";
import React, { Suspense } from "react";
import { BrowserRouter } from "react-router";

import { AnimatedRoutes } from "./components/AnimatedRoutes";

const DevTools = React.lazy(() =>
  import("@/features/debugging/dev-tools/DevTools").then((m) => ({
    default: m.DevTools,
  }))
);

export const AppRouter: React.FC = () => {
  return (
    <BrowserRouter>
      <Layout>
        <KioskLockOverlay />
        <Suspense fallback={null}>
          <DevTools />
        </Suspense>
        <AnimatedRoutes />
      </Layout>
    </BrowserRouter>
  );
};
